import { createContext, PropsWithChildren } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormProvider } from '../forms/FormProvider';

// Dynamic controller-state bag; consumers read many runtime fields.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ModelFiltersContextValue = Record<string, any>;

export const ModelFiltersContext = createContext<
  ModelFiltersContextValue | undefined
>(undefined);

interface ModelFiltersProviderProps {
  methods: UseFormReturn;
  [key: string]: unknown;
}

export const ModelFiltersProvider = ({
  children,
  ...props
}: PropsWithChildren<ModelFiltersProviderProps>) => {
  const { methods } = props;

  return (
    <ModelFiltersContext value={{ ...props }}>
      <FormProvider {...methods}>{children}</FormProvider>
    </ModelFiltersContext>
  );
};
